import { types } from "../Actions/types";

const initialState = {
  exercisegoallist: [],
  error: null,
  exerciseGoalSingle: "",
  popupmodel: "",
};

const ExerciseGoal = (state = initialState, action) => {
  let { type, payload, error } = action;
  if (payload && payload.error !== null) {
    error = payload.error;
  }

  switch (type) {
    case types.EXERCISE_GOAL_LIST:
      return {
        ...state,
        exercisegoallist: payload,
        error,
      };
    case types.EXERCISE_GOAL_SINGLE:
      return {
        ...state,
        exerciseGoalSingle: payload,
        error,
      };
    case types.EXERCISE_GOAL_FORM_MODEL:
      return {
        ...state,
        popupmodel: payload,
      };

    default:
      return state;
  }
};

export default ExerciseGoal;
